import { StateType } from '..';

export const selectDataObjects = (state: StateType) => state.dataObjects.dataObjects;

export const selectFilters = (state: StateType) => state.dataObjects.filters;

export const selectPagination = (state: StateType) => state.dataObjects.pagination;

export const selectSorting = (state: StateType) => state.dataObjects.sorting;
